import getPermissions from "./utils/getPermissions";
import omitEmpty from "./utils/omitEmpty";
var showDealVisibility = function (token) {
    var deals = getPermissions(token, "deals", ["deals"], ["read"]);
    var tags = getPermissions(token, "deals", ["tags"], ["read"]);
    var customPermissions = getPermissions(token, "identity", ["custom-permissions"], ["update"]);
    return deals && tags && customPermissions;
};
var showSSO = function (token, auth) {
    var tenant = auth.userTenant;
    var saml = getPermissions(token, "sso", ["saml"], ["create", "delete"]);
    var provider = getPermissions(token, "sso", ["provider"], ["read"]);
    var showSSOOptions = tenant.settings.showSSOOptions;
    return saml && provider && showSSOOptions;
};
export default {
    get: function (token, auth) {
        var people = getPermissions(token, "identity", ["users"], ["read", "create", "update"]);
        var teams = getPermissions(token, "identity", ["teams"], ["read", "create", "update", "delete"]);
        var tenant = getPermissions(token, "identity", ["tenants"], ["read", "update"]);
        var selfSignUp = getPermissions(token, "self-signup", ["signup"], ["read", "create", "update"]);
        var customPermissions = getPermissions(token, "identity", ["custom-permissions"], ["update"]);
        var reportingV3 = auth.featureFlags.isReportingV3Enabled;
        var dealVisibility = showDealVisibility(token);
        var sso = showSSO(token, auth);
        var permission = {
            people: people,
            teams: teams,
            tenant: tenant,
            selfSignUp: selfSignUp,
            dealVisibility: dealVisibility,
            sso: sso,
            reportingV3: reportingV3,
            customPermissions: customPermissions
        };
        return omitEmpty(permission);
    }
};
